import wixData from 'wix-data';
import wixLocation from 'wix-location';

$w.onReady(function () {
	$w('#dataset1').onReady(() => {
		$w('#dropdown1').onChange(() => {
			let currentIndex = $w('#dropdown1').selectedIndex;
			$w('#dataset1').setCurrentItemIndex(currentIndex)
				.then(() => {
					let myURL = $w('#dataset1').getCurrentItem().webLink;
					console.log(myURL)
					$w('#button11').link = myURL;
				})
		})
	})
});